var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "my-genjin-list" }, [
    _c(
      "ul",
      { staticClass: "list" },
      _vm._l(_vm.list, function (item, index) {
        return _c("li", { staticClass: "item" }, [
          _c("span", { staticClass: "block" }, [
            _c("span", { staticClass: "lable" }, [_vm._v("序号：")]),
            _vm._v(_vm._s(index + 1)),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "inline" }, [
            _c("span", { staticClass: "lable" }, [_vm._v("类型：")]),
            _vm._v(_vm._s(item.type == "system" ? "系统" : "写入")),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "inline" }, [
            _c("span", { staticClass: "lable" }, [_vm._v("员工：")]),
            _vm._v(_vm._s(item.login_name)),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "inline" }, [
            _c("span", { staticClass: "lable" }, [_vm._v("日期：")]),
            _vm._v(_vm._s(item.add_time)),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "block" }, [
            _c("span", { staticClass: "lable" }, [_vm._v("跟进内容：")]),
            _vm._v(_vm._s(item.content)),
          ]),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _vm.list.length == 0
      ? _c("div", { staticClass: "list-null" }, [_vm._v(" 暂无数据 ")])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }